import { render } from "./PlanTreatmentTemplateDatatableFormComplexServices.vue?vue&type=template&id=7998590e"
import script from "./PlanTreatmentTemplateDatatableFormComplexServices.vue?vue&type=script&lang=js"
export * from "./PlanTreatmentTemplateDatatableFormComplexServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__